export default __webpack_public_path__ + "static/media/group-material.79a24caf.png";